if (!customElements.get('yc-featured-collection-tabs')) {
  class YcFeaturedCollectionTabs extends HTMLElement {
    connectedCallback() {

      function initTabs(section) {
        const navWrapper = section.querySelector('.yc-featured-tabs__nav-wrapper');
        const content = section.querySelector('.yc-featured-tabs__content');
        const navItems = section.querySelectorAll('.yc-featured-tabs__nav-item');
        const panels = section.querySelectorAll('.yc-featured-tabs__panel');
        const autoSwitch = section.dataset.autoSwitch === 'true';
        const autoSwitchInterval = parseInt(section.dataset.autoSwitchInterval, 10) * 1000 || 5000;
        let switchInterval;
        let touchStartX = 0;
        let touchStartY = 0;
        
        if (navItems.length === 0 || panels.length === 0) return;
  
        function switchTab(index) {
          navItems.forEach(n => n.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          
          const navItem = navItems[index];
          navItem.classList.add('is-active');
          if (panels[index]) {
            panels[index].classList.add('is-active');
          }
          
          if (navWrapper) {
            const scrollLeft = navItem.offsetLeft - (navWrapper.clientWidth / 2) + (navItem.clientWidth / 2);
            navWrapper.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            });
          }
        }

      function startAutoSwitch() {
        if (!autoSwitch) return;
        stopAutoSwitch();
        switchInterval = setInterval(() => {
          let currentIndex = Array.from(navItems).findIndex(item => item.classList.contains('is-active'));
          let nextIndex = (currentIndex + 1) % navItems.length;
          switchTab(nextIndex);
        }, autoSwitchInterval);
      }

      function stopAutoSwitch() {
        if (switchInterval) {
          clearInterval(switchInterval);
        }
      }

      // Add event listeners for flag clicks to show overlay
      const flags = section.querySelectorAll('.yc-featured-tabs__flag');
      flags.forEach(flag => {
        flag.addEventListener('click', (e) => {
          e.preventDefault();
          const mainImage = flag.closest('.yc-featured-tabs__main-image');
          if (mainImage) {
            const overlay = mainImage.querySelector('.yc-featured-tabs__overlay');
            if (overlay) {
              overlay.classList.add('is-visible');
              stopAutoSwitch(); // Pause auto switch while reading
            }
          }
        });
      });

      // Add event listeners to close overlay
      const overlays = section.querySelectorAll('.yc-featured-tabs__overlay');
      overlays.forEach(overlay => {
        const closeOverlay = (e) => {
          e.preventDefault();
          overlay.classList.remove('is-visible');
          startAutoSwitch();
        };

        overlay.addEventListener('click', closeOverlay);
      });

      navItems.forEach((navItem, index) => {
        navItem.addEventListener('click', () => {
          switchTab(index);
          startAutoSwitch();
        });
      });

      if (content) {
        content.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;

          stopAutoSwitch();
          touchStartX = touch.screenX;
          touchStartY = touch.screenY;
        }, { passive: true });

        content.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const swipeThreshold = 50;
          let currentIndex;
          let deltaX;
          let deltaY;

          if (!touch) {
            startAutoSwitch();
            return;
          }

          currentIndex = Array.from(navItems).findIndex((item) => item.classList.contains('is-active'));
          deltaX = touch.screenX - touchStartX;
          deltaY = touch.screenY - touchStartY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeThreshold) {
            if (deltaX < 0) {
              switchTab((currentIndex + 1) % navItems.length);
            } else {
              switchTab((currentIndex - 1 + navItems.length) % navItems.length);
            }
          }

          startAutoSwitch();
        }, { passive: true });
      }

      section.addEventListener('mouseenter', stopAutoSwitch);
      section.addEventListener('mouseleave', startAutoSwitch);

      startAutoSwitch();
    }

    initTabs(this);

    if (window.Shopify && Shopify.designMode) {
      
      
      document.addEventListener('shopify:block:select', function(event) {
        const block = event.target;
        const section = block.closest('.yc-featured-tabs');
        if (!section) return;
        
        const index = block.getAttribute('data-index');
        const navItem = section.querySelector(`.yc-featured-tabs__nav-item[data-index="${index}"]`);
        
        if (navItem) navItem.click();
      });
    }
  
    }
  }
  customElements.define('yc-featured-collection-tabs', YcFeaturedCollectionTabs);
}
